import { Edit, Trash, View, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ViewUsers = ({ closeViewUsers, roleUsers, deleteUser }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={(e) => {
        closeViewUsers();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[600px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeViewUsers}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="text-[15px] font-medium uppercase font-bold">
          Admin users
        </p>
        <p className="text-[14px] font-bold font-normal">
          Here is a list of users under the specific role.
        </p>
        <div className="h-[520px] overflow-y-auto">
          <div className="h-[40px] w-full bg-[#F3F3F3] mt-[20px] px-[10px] flex items-center">
            <div className="w-[10%] text-[#222222] font-medium text-[14px]">
              ID
            </div>
            <div className="w-[18%] text-[#222222] font-medium text-[14px]">
              NAME
            </div>
            <div className="w-[15%] uppercase text-[#222222] font-medium text-[14px]">
              Mobile
            </div>
            <div className="w-[27%] uppercase text-[#222222] font-medium text-[14px]">
              Email
            </div>
            <div className="w-[15%] uppercase text-[#222222] font-medium text-[14px]">
              Branch
            </div>
            <div className="w-[15%] truncate text-[#222222] font-medium text-[14px]">
              VIEW/ DOWNLOAD/ EDIT
            </div>
          </div>
          {roleUsers.length > 0 ? (
            roleUsers.map((user) => (
              <div className="h-[35px] w-full my-[10px] px-[10px] flex items-center">
                <div
                  onClick={() => navigate(`/dashboard/users/${user?.id}`)}
                  className="w-[10%] text-[#000000] cursor-pointer truncate text-[#222222] font-normal text-[14px]"
                >
                  {user?.public_id}
                </div>
                <div className="w-[18%] truncate text-[#222222] font-normal text-[14px]">
                  {user?.firstname} {user?.lastname}
                </div>
                <div className="w-[15%] truncate text-[#222222] font-normal text-[14px]">
                  {user?.phone}
                </div>
                <div className="w-[27%] truncate text-[#222222] font-normal text-[14px]">
                  {user?.email}
                </div>
                <div className="w-[15%] truncate text-[#222222] font-normal text-[14px]">
                  Kahawa West
                </div>
                <div className="w-[15%] truncate flex items-center gap-[15px] truncate text-[#222222] font-normal text-[14px]">
                  <View
                    onClick={() => navigate(`/dashboard/users/${user?.id}`)}
                    size={16}
                    className="cursor-pointer"
                  />
                  <Edit size={16} color="blue" />
                  <Trash
                    size={16}
                    className="cursor-pointer"
                    color="red"
                    onClick={() => deleteUser(user?.id)}
                  />
                </div>
              </div>
            ))
          ) : (
            <div>
              <p>Role user not available</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewUsers;
